import SystemConnection from '@/utils/system/SystemConnection'
import store from '@/vuex/store'

SystemConnection.initEventHandlers({
  onUserConnectionUpdate: (status) => {
    store.dispatch('systemConnection/setUserConnection', status)
  },
  onSocketConnectionUpdate: (status) => {
    store.dispatch('systemConnection/setSocketConnection', status)
  },
  onEmqxConnectionUpdate: (status) => {
    store.dispatch('systemConnection/setEmqxConnection', status)
  },
  onGeneralConnectionUpdate: (status) => {
    store.dispatch('systemConnection/setGeneralApiConnection', status)
  },
  onLiveApiConnectionUpdate: (status) => {
    store.dispatch('systemConnection/setLiveApiConnection', status)
  },
})

SystemConnection.detectUserConnection()
